import { render } from "./CreateBill.vue?vue&type=template&id=c875a6fc&scoped=true"
import script from "./CreateBill.vue?vue&type=script&lang=js"
export * from "./CreateBill.vue?vue&type=script&lang=js"

import "./CreateBill.vue?vue&type=style&index=0&id=c875a6fc&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c875a6fc"]])

export default __exports__